// extracted by mini-css-extract-plugin
module.exports = {"wrap":"AuthWrapper_wrap__nYnVk","header":"AuthWrapper_header__2dAIE","subheader":"AuthWrapper_subheader__3JUJz","logo":"AuthWrapper_logo__2dShH"};